import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import LevelMarkingInfo from './LevelMarkingInfo';
import TableCellStudent from './TableCellStudent';

const TableRowViewGeneral = ({
  student,
  granularSteps,
  levels,
  index,
  currentCurriculum,
  size = 30,
  isLoading,
  completed = 'completedTeacher',
  completedType = 'completedTeacherValue'
}) => {
  let markingValue = 0;
  return (
    <TableRow key={`guttman-chart-table-student-${student._id}`}>
      <TableCellStudent student={student} index={index} />
      {granularSteps.map((gs) => {
        const { lc } = gs;
        const levelsData = levels.find((level) => level._id === gs.levelId);
        markingValue+= gs?.logs?.find((log) => log.markingType === completed)?.markingValue || 0;
        return (
          <TableCell
            key={`guttman-chart-table-student-${student._id}-lc-${lc._id}-gs-${gs.id}`}
            style={{ padding: 0.5, width: size }}
          >

            <LevelMarkingInfo
              isLoading={isLoading}
              lc={lc}
              level={{
                gsId: gs.id,
                levelId: gs.levelId,
                definition: gs?.definition || '',
                name: levelsData?.name || ''
              }}
              marking={{
                studentId: student._id,
                ...(gs?.logs?.find((log) => log.markingType === completed) || {}),
                markingValue,
              }}
              size={size}
              currentCurriculum={currentCurriculum}
            />
          </TableCell>
        );
      })}
       {/* <TableCell
          key={`guttman-chart-table-student-${student._id}`}
          style={{ padding: 0.5, width: size }}
        >
          {student?.[completedType]}
        </TableCell> */}
    </TableRow>
  );
};

export default TableRowViewGeneral;
